import type { Viewpoint } from './viewpoint'

/** Um viewpoint sem nada da cena para repor: imagem anexada, ou o
 *  viewpoint neutro que as versões anteriores gravavam para imagens e
 *  importações (câmara ortogonal em (0,0,1) a olhar para -Z, sem
 *  selecção, sem corte e sem medições nem anotações).
 *
 *  Fica num ficheiro sem dependências para o slice do BCF o poder usar
 *  sem carregar o viewer. */
export function semCena(vp: Viewpoint): boolean {
  if (vp.so_imagem) return true
  if (vp.components_only) return false
  const c = vp.camera
  const neutra =
    c.mode === 'orthographic' &&
    c.position.x === 0 && c.position.y === 0 && c.position.z === 1 &&
    c.direction.x === 0 && c.direction.y === 0 && c.direction.z === -1
  return (
    neutra &&
    vp.components.selected_global_ids.length === 0 &&
    !vp.components.section?.enabled &&
    !vp.vn2r_extras?.measurements?.length &&
    !vp.vn2r_extras?.annotations?.length
  )
}
